export enum SecurityEnum {
	NoAccess,
	ReadOnly,
	Conditional,
	FullAccess
}
